export type ForumThreadDetailView<TThread extends { posts: readonly unknown[] }> =
  | { status: 'loading' }
  | {
      status: 'ready';
      thread: TThread;
      openingPost: TThread['posts'][number] | undefined;
      replies: Array<TThread['posts'][number]>;
    };

export function forumThreadDetailView<TThread extends { posts: readonly unknown[] }>(
  _isLoading: boolean,
  thread: TThread | undefined,
): ForumThreadDetailView<TThread> {
  if (thread) {
    const posts = Array.isArray(thread.posts) ? thread.posts : [];
    const [openingPost, ...replies] = posts;
    return { status: 'ready', thread, openingPost, replies };
  }

  return { status: 'loading' };
}
